import React from "react";
import { Box, Paper, Typography, Grid, Avatar } from "@mui/material";
import {
  Person as PersonIcon,
  Place as PlaceIcon,
  LocalShipping as LocalShippingIcon,
} from "@mui/icons-material";

const TrackingDriverSummary = ({ data }) => {
  return (
    <Grid container spacing={1.5} sx={{ mb: 2 }}>
      <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
        <Paper
          variant="outlined"
          sx={{
            p: 1.25,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            height: "100%",
            width: "100%",
          }}
        >
          <Avatar sx={{ bgcolor: "primary.light", color: "primary.main", width: 38, height: 38 }}>
            <PersonIcon sx={{ fontSize: 21 }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: "12px" }} color="text.secondary">
              Driver
            </Typography>
            <Typography sx={{ fontSize: "15px" }} fontWeight="medium">
              {data.driverName}
            </Typography>
            {data.driverPhone && data.driverPhone !== "N/A" && (
              <Typography sx={{ fontSize: "12px" }} color="text.secondary">
                {data.driverPhone}
              </Typography>
            )}
          </Box>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
        <Paper
          variant="outlined"
          sx={{
            p: 1.25,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            height: "100%",
            width: "100%",
          }}
        >
          <Avatar sx={{ bgcolor: "success.light", color: "success.main", width: 38, height: 38 }}>
            <PlaceIcon sx={{ fontSize: 21 }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: "12px" }} color="text.secondary">
              Stops Completed
            </Typography>
            <Typography sx={{ fontSize: "15px" }} fontWeight="medium">
              {data.completedStops} / {data.totalStops} stops
            </Typography>
          </Box>
        </Paper>
      </Grid>

      <Grid item xs={12} sm={6} md={4} sx={{ display: "flex" }}>
        <Paper
          variant="outlined"
          sx={{
            p: 1.25,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            height: "100%",
            width: "100%",
          }}
        >
          <Avatar sx={{ bgcolor: "warning.light", color: "warning.main", width: 38, height: 38 }}>
            <LocalShippingIcon sx={{ fontSize: 21 }} />
          </Avatar>
          <Box>
            <Typography sx={{ fontSize: "12px" }} color="text.secondary">
              Orders Delivered
            </Typography>
            <Typography sx={{ fontSize: "15px" }} fontWeight="medium">
              {data.deliveredOrders} / {data.totalOrders} orders
            </Typography>
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TrackingDriverSummary;
